module.exports = __webpack_public_path__ + "img/river.aef1e806.png";